import React from 'react';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SensorDataItem from '../SensorDataItem';
import { SensorLatest, VarName } from '../../../services/api';
import useStyles from '../../../styles';

interface SensorDataProps {
  sensorDetails: SensorLatest | undefined;
}

function SensorData({ sensorDetails }: SensorDataProps): JSX.Element {
  const classes = useStyles();
  const onlineStatusValue = sensorDetails?.data?.find(
    (d) => d.varName === VarName.OnlineStatus
  )?.value;

  return (
    <Grid item xs={12} sm={6}>
      <Paper elevation={0}>
        <List>
          <ListItem>
            <AssessmentIcon className={classes.icon} style={{ alignSelf: 'center' }} />
            <Typography variant="h6" style={{ marginLeft: '10px' }}>
              Sensor Data
            </Typography>
          </ListItem>
          <Divider />
          {sensorDetails?.data?.map((item) => (
            <Box key={item.varName}>
              <SensorDataItem
                sensorId={sensorDetails.id}
                dataItem={item}
                isOnline={onlineStatusValue !== undefined && onlineStatusValue > 0}
              />
            </Box>
          ))}
        </List>
      </Paper>
    </Grid>
  );
}

export default SensorData;
